<template>
<div class="chapter">
<div class="inner_page">
<h1>The Pleasure of the Rose</h1>
<h3 class="sigil_not_in_toc"><i>The MacNeil Legacy - Book One</i></h3>
<h2 class="sigil_not_in_toc">Jane Bonander</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TitlePage.vue?2242822e